"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
const getInitialContext = () => {
  return {
    customerCode: null,
    maxRetries: 3,
    retries: 0,
    retryDelayMs: 2000,
    availByLocId: null,
    apptInfo: null,
    visibility: ['consumer:direct_book'],
    role: 'consumer',
    canBookOnline: false,
    locations: [],
    provider: null
  };
};
var _default = exports.default = getInitialContext;